import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "views/Home";
import Consent from "views/Consent";
import Relationship from "views/Relationship";
import Sex from "views/Sex";
import PageNotFound from "views/PageNotFound";


const App = () => {

  return (
        <div className="app">
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/consent" element={<Consent />} />
            <Route path="/relationships" element={<Relationship />} />
            <Route path="/sex" element={<Sex />} />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
        </div>

  );
};

export default App;
